// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__1idTq","spinner":"Spinner_spinner__kptye","fadeOut":"Spinner_fadeOut__31G6o"};